import { generateClient } from "aws-amplify/api";

const client = generateClient();

export async function requestGetForum(dispatch, payload) {
  try {
    const { id, commentLimit = 5 } = payload;

    dispatch({ type: "REQUEST_GET_FORUM" });

    const params = {
      id,
      commentLimit,
    };

    const res = await client.graphql({
      query: getForum,
      variables: params,
    });

    const forum = res.data.getForum;

    if (!forum) throw new Error("Forum not found.");

    dispatch({
      type: "GET_FORUM_SUCCESS",
      payload: { forum },
    });
  } catch (error) {
    dispatch({ type: "GET_FORUM_ERROR", payload: { error } });
  }
}

export async function requestListForum(dispatch, payload) {
  try {
    const {
      page,
      categoryID,
      limit = 10,
      createdAt = "",
      sortDirection = "DESC",
      nextToken = null,
    } = payload;

    dispatch({ type: "REQUEST_LIST_FORUM", payload: { page } });

    const params = {
      categoryID: categoryID,
      limit,
      sortDirection,
      nextToken,
    };

    if (createdAt) params.createdAt = createdAt;

    const res = await client.graphql({
      query: forumsByCategoryCreatedAt,
      variables: params,
    });

    const { items, nextToken: token } = res.data.forumsByCategoryCreatedAt;
    const nextPage = page + 1;

    dispatch({
      type: "LIST_FORUM_SUCCESS",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    dispatch({ type: "LIST_FORUM_ERROR", payload: { error } });
  }
}

export async function requestListForumCategory(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_LIST_FORUM_CATEGORY" });

    const res = await client.graphql({
      query: listForumCategories,
    });

    const { items, nextToken: token } = res.data.listForumCategories;

    dispatch({
      type: "LIST_FORUM_CATEGORY_SUCCESS",
      payload: { items, nextToken: token },
    });
  } catch (error) {
    dispatch({ type: "LIST_FORUM_CATEGORY_ERROR", payload: { error } });
  }
}

export async function requestCreateForum(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_CREATE_FORUM" });

    const { input } = payload;

    const res = await client.graphql({
      query: createForum,
      variables: { input },
    });

    dispatch({
      type: "CREATE_FORUM_SUCCESS",
      payload: { forum: res.data.createForum },
    });
  } catch (error) {
    dispatch({ type: "CREATE_FORUM_ERROR", payload: { error } });
  }
}

export async function requestListComment(dispatch, payload) {
  try {
    const { forumID, limit = 5, sortDirection = "DESC" } = payload;

    dispatch({ type: "REQUEST_LIST_COMMENT" });

    const params = {
      forumID,
      limit,
      sortDirection,
    };

    const res = await client.graphql({
      query: commentsByForumCreatedAt,
      variables: params,
    });

    const { items, nextToken: token } = res.data.commentsByForumCreatedAt;

    dispatch({
      type: "LIST_COMMENT_SUCCESS",
      payload: { items, nextToken: token },
    });
  } catch (error) {
    dispatch({ type: "LIST_COMMENT_ERROR", payload: { error } });
  }
}

export async function requestListNextComment(dispatch, payload) {
  try {
    const {
      forumID,
      limit = 5,
      sortDirection = "DESC",
      nextToken = null,
    } = payload;

    dispatch({ type: "REQUEST_LIST_NEXT_COMMENT" });

    const params = {
      forumID,
      limit,
      sortDirection,
      nextToken,
    };

    const res = await client.graphql({
      query: commentsByForumCreatedAt,
      variables: params,
    });

    const { items, nextToken: token } = res.data.commentsByForumCreatedAt;

    dispatch({
      type: "LIST_NEXT_COMMENT_SUCCESS",
      payload: { items, nextToken: token },
    });
  } catch (error) {
    dispatch({ type: "LIST_NEXT_COMMENT_ERROR", payload: { error } });
  }
}

export async function requestCreateComment(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_CREATE_COMMENT" });
    const { input } = payload;
    const res = await client.graphql({
      query: createComment,
      variables: { input },
    });
    dispatch({
      type: "CREATE_COMMENT_SUCCESS",
      payload: { comment: res.data.createComment },
    });
  } catch (error) {
    dispatch({ type: "CREATE_COMMENT_ERROR", payload: { error } });
  }
}

const createForum = /* GraphQL */ `
  mutation CreateForum($input: CreateForumInput!) {
    createForum(input: $input) {
      id
      url
      userID
      categoryID
      title
      description
      image {
        bucket
        region
        key
      }
      document {
        bucket
        region
        key
      }
      createdAt
      updatedAt
      user {
        id
        name
      }
      category {
        id
        name
      }
    }
  }
`;

const createComment = /* GraphQL */ `
  mutation CreateComment($input: CreateCommentInput!) {
    createComment(input: $input) {
      id
      forumID
      userID
      description
      createdAt
      updatedAt
      user {
        id
        name
      }
    }
  }
`;

const forumsByCategoryCreatedAt = /* GraphQL */ `
  query ForumsByCategoryCreatedAt(
    $categoryID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelForumFilterInput
    $limit: Int
    $nextToken: String
  ) {
    forumsByCategoryCreatedAt(
      categoryID: $categoryID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        url
        userID
        categoryID
        title
        description
        image {
          bucket
          region
          key
        }
        document {
          bucket
          region
          key
        }
        createdAt
        updatedAt
        user {
          id
          name
        }
        category {
          id
          name
          createdAt
          updatedAt
        }
        comments {
          items {
            id
            forumID
            userID
            description
            createdAt
            updatedAt
            user {
              id
              name
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;

const getForum = /* GraphQL */ `
  query GetForum($id: ID!) {
    getForum(id: $id) {
      id
      url
      userID
      categoryID
      title
      description
      image {
        bucket
        region
        key
      }
      document {
        bucket
        region
        key
      }
      createdAt
      updatedAt
      user {
        id
        name
      }
      category {
        id
        name
        createdAt
        updatedAt
      }
      comments {
        nextToken
      }
    }
  }
`;

const commentsByForumCreatedAt = /* GraphQL */ `
  query CommentsByForumCreatedAt(
    $forumID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentsByForumCreatedAt(
      forumID: $forumID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        forumID
        userID
        description
        createdAt
        updatedAt
        user {
          id
          name
        }
      }
      nextToken
    }
  }
`;

const listForumCategories = /* GraphQL */ `
  query ListForumCategories(
    $filter: ModelForumCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listForumCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
